export interface IFloatingMenuSizesUnit {
  LEFT: number;
  BOTTOM: number;
}

export type FloatingMenuType =
  "rides" | "bookingsGrid" | "bookingsCalendar" | "coursesCalendar" | "common";
export type FloatingMenuMobileCategory = "mobile" | "desktop";

export type TFloatingMenuSized = {
  [type in FloatingMenuType]: Record<
    FloatingMenuMobileCategory,
    IFloatingMenuSizesUnit
  >;
};

export const floatingPanelSizes: TFloatingMenuSized = {
  rides: {
    desktop: {
      LEFT: 350,
      BOTTOM: 20,
    },
    mobile: {
      LEFT: 190,
      BOTTOM: 70,
    },
  },
  bookingsGrid: {
    desktop: {
      LEFT: 350,
      BOTTOM: 20,
    },
    mobile: {
      LEFT: 190,
      BOTTOM: 70,
    },
  },
  bookingsCalendar: {
    desktop: {
      LEFT: 350,
      BOTTOM: 20,
    },
    mobile: {
      LEFT: 190,
      BOTTOM: 70,
    },
  },
  coursesCalendar: {
    desktop: {
      LEFT: 350,
      BOTTOM: 20,
    },
    mobile: {
      LEFT: 190,
      BOTTOM: 70,
    },
  },
  common: {
    desktop: {
      LEFT: 350,
      BOTTOM: 20,
    },
    mobile: {
      LEFT: 110,
      BOTTOM: 70,
    },
  },
} as const;
